/* src/app/warehousing/pages/product-classes/product-classes.component.scss */
/*# sourceMappingURL=product-classes.component.css.map */
